import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserProfile } from '../../../domain/models/user-profile.model';

@Component({
  selector: 'talk-to-your-data-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileComponent {
  @Input() userProfile: UserProfile | null = null;

  get initials(): string {
    return this.userProfile?.initials || '?';
  }

  get fullName(): string {
    return this.userProfile?.fullName || 'Unknown User';
  }

  get role(): string {
    return this.userProfile?.role || 'No role assigned';
  }
}
